import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CoreService } from '../core.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private coreService: CoreService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (!this.coreService.isLoggedIn()) {
      this.router.navigate(['/identificate']);
      return false;
    }
    else {

      let _role = this.coreService.getUserRol();
      let isValid: boolean = false;

      switch (_role) {
        case "empresa":
          isValid = true;
          break;
        case "explotacion":
          isValid = true;
          break;
        default:
          isValid = false;
          break;
      }

      if (isValid && this.coreService.isLoggedIn() && state.url == "/menu") {
        this.router.navigate(['/menu/resultados']);
      }

      return isValid;

    }
  }
}
